import { io } from 'socket.io-client';

const WS_URL = process.env.REACT_APP_WS_URL || 'http://localhost:3000';

class WebSocketService {
  constructor() {
    this.socket = null;
    this.subscribers = new Map();
  }

  connect(token) {
    if (this.socket?.connected) {
      return;
    }

    this.socket = io(WS_URL, {
      auth: { token },
      transports: ['websocket'],
    });

    this.socket.on('connect', () => {
      console.log('✅ WebSocket connected');
    });

    this.socket.on('disconnect', () => {
      console.log('❌ WebSocket disconnected');
    });

    this.socket.on('ticker', (data) => {
      this.notify('ticker', data);
    });

    this.socket.on('orderbook', (data) => {
      this.notify('orderbook', data);
    });

    this.socket.on('trade', (data) => {
      this.notify('trade', data);
    });

    this.socket.on('balance', (data) => {
      this.notify('balance', data);
    });

    this.socket.on('order', (data) => {
      this.notify('order', data);
    });

    // P2P Chat messages
    this.socket.on('p2p_message', (data) => {
      this.notify('p2p_message', data);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  subscribe(event, callback) {
    if (!this.subscribers.has(event)) {
      this.subscribers.set(event, new Set());
    }
    this.subscribers.get(event).add(callback);

    // Return unsubscribe function
    return () => {
      const callbacks = this.subscribers.get(event);
      if (callbacks) {
        callbacks.delete(callback);
      }
    };
  }

  on(event, callback) {
    return this.subscribe(event, callback);
  }

  off(event, callback) {
    const callbacks = this.subscribers.get(event);
    if (callbacks) {
      callbacks.delete(callback);
    }
  }

  notify(event, data) {
    const callbacks = this.subscribers.get(event);
    if (callbacks) {
      callbacks.forEach((callback) => callback(data));
    }
  }

  subscribeToMarkets(symbols) {
    if (this.socket) {
      this.socket.emit('subscribe', { symbols });
    }
  }

  unsubscribeFromMarkets(symbols) {
    if (this.socket) {
      this.socket.emit('unsubscribe', { symbols });
    }
  }

  subscribeToMarketData(symbol) {
    this.subscribeToMarkets([symbol]);
  }

  unsubscribeFromMarketData(symbol) {
    this.unsubscribeFromMarkets([symbol]);
  }

  getSocket() {
    return this.socket;
  }
}

export default new WebSocketService();
